import { LabelService } from '../../helpers/services/label.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'
import { ddlHelper } from "@/utils";

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const LABEL_MODULE = 'label';

// define action 
export const GET_ALL_LABELS = 'getAllLabels';
export const GET_LABEL = 'getLabel';
export const UPDATE_LABEL = 'updateLabel';
export const CREATE_LABEL = 'createLabel';
export const UPDATE_LABEL_STATUS = 'updateLabelStatus';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_LABELS_REQUEST = "getAllLabels";
const GET_LABEL_REQUEST = "getLabel";

export const actions = {
    // eslint-disable-next-line no-unused-vars
     [GET_ALL_LABELS]({ commit }, { filter }) {
         LabelService
            .getAllLabels(filter)
            .then(
                (result) => {
                    commit(GET_ALL_LABELS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
     [GET_LABEL]({ commit }, { id }) {
        LabelService
            .getLabel(id)
            .then(
                (result) => {
                    commit(GET_LABEL_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_LABEL]({ commit }, { data }) {
        commit(REQUEST)
        LabelService
            .updateLabel(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.Label')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_LABEL]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            var result = await LabelService.createLabel(data);
            return_result['type_uuid'] = result.data.uuid;
            const message = i18n.t("message.createXSuccess", [i18n.t('module.Label')]);
            sharedHelper.alertSuccessMessage(message);

            if (redirect) {
                commit(SUCCESS);
            } else {
                commit(SUCCESS_WITHOUT_REDIRECT);
            }

            return_result['result'] = true

        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
            return_result['result'] = false
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_LABEL_STATUS]({ dispatch }, { filter, data }) {
        LabelService
            .updateLabelStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_LABELS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },


};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Label-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_LABELS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                text: o.text,
                localeName: o.locale_name,
                color: o.color,
                description: o.description,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
                
            }
        })
    },
    [GET_LABEL_REQUEST](state, data) {
        let o = data.data
        const languages = ddlHelper.getLanguages();

        var names = null;

        if (o.locale_name != null) {
            names = [];
            Object.keys(o.locale_name.text).forEach(key => {
                names.push({ language: languages.find(lang => lang.code === key), text: o.locale_name.text[key] });
            });
        }
        else {
            names = []
        }
        
        state.details = {
            uuid: o.uuid,
            names: names,
            name: o.name,
            text: o.text,
            color: o.color,
            description: o.description,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }
    }
}


